import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import store from './../../store';

const success = (data) => {
  store.dispatch('fetchCurrentEdiOrder', ediOrderTransformer.fetch(data));
};

export default (id, ediOrder) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`edi_orders/${id}/link_order`, ediOrderTransformer.send(ediOrder))
      .then((response) => {
        success(response.data);
        resolve();
      })
      .catch(() => {
        reject();
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/linkOrder.js